/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-08-22 11:03:46
 * @version 1.0.0
 */

import React, { PureComponent } from 'react';
import { bindActionCreators, Dispatch } from '@tkit/actions';
import { connect } from 'react-redux';

import history from '@src/common/history';

import { classnames } from '@src/utils';

import { GlobalSearchInfoCondition } from '@src/services';
import { IRootState } from '@src/types';

import { Input } from 'antd';
import { IconFont } from '@src/features/common/Icon';
import actions from '../redux/actions';

import './Search.less';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

const mapStateToProps = (state: IRootState) => ({
  search: state.home.search
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;

interface State {
  value: string;
  open: boolean;
  searchAutocompleteStatus: string;
}

/* eslint-disable @typescript-eslint/camelcase */
class Search extends PureComponent<Props, State> {
  private input: HTMLInputElement;

  public state: State = {
    value: '',
    open: false,
    searchAutocompleteStatus: 'init'
  };

  public clickIcon = () => {
    const { open } = this.state;

    if (!open) {
      this.setState(
        {
          open: true
        },
        () => {
          this.input.focus();
        }
      );
    }
  };

  public saveInput = (node: HTMLInputElement) => {
    this.input = node;
  };

  public hideSearch = () => {
    this.setState({
      open: false
    });
  };

  public handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    this.setState({
      value
    });
  };

  public handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      const { value } = this.state;

      this.hideSearch();

      history.push(`/search/ARTICLE/${encodeURIComponent(value)}`);
    }
  };

  public render() {
    const { clickIcon, hideSearch, handleChange, handleKeyUp, saveInput } = this;
    const { search } = this.props;
    const { open, value } = this.state;

    const hasTag = search.list.find((group: GlobalSearchInfoCondition) => {
      return group.typeName === 'TAG';
    });

    return (
      <div className={classnames('k-tech-com-search', { autocomplete__tagged: hasTag })}>
        <div className="search__icon" onClick={clickIcon}>
          <IconFont type="icon-search" />
        </div>

        <div className={`search__autocomplete ${open ? 'vertical--spread' : 'vertical--collapse'}`}>
          <input
            placeholder="搜索"
            className="search__input"
            value={value}
            onBlur={hideSearch}
            onChange={handleChange}
            onKeyUp={handleKeyUp}
            ref={saveInput}
          />
        </div>
      </div>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(Search);
